<template>
  <div class="">
    <div>
      <p class="text-xl text-brand-black font-medium leading-8">
        <slot></slot>
      </p>
    </div>
    <div class="flex items-center justify-between mt-6">
      <div class="flex items-center space-x-4">
        <img class="rounded-full h-full max-h-12" :src="image" />
        <div class="text-brand-brown font-semibold">
          <slot name="author"></slot>
        </div>
      </div>
      <div>
        <img :src="require(`@/assets/img/quotation-mark.svg`)" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Testimonial',
  props: ['image'],
};
</script>
